import { CompanyService } from "../../Services";
import { BaseStateModel, PriceModel, DataTableModel, UserModel, CompanyModel, NetworkModel } from "../Models";
import { VisibilityIcon } from '../../Helpers/Icons';

export class DashboardSideMenuState extends BaseStateModel {
    public sideMenuStatus: any = {};
}